var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.25C1 11.5247 2.37641 10.125 4.07292 10.125C4.50825 10.125 4.92437 10.2161 5.30208 10.3822M14.9818 10.4603C15.3979 10.2454 15.8652 10.125 16.3646 10.125C18.0611 10.125 19.4375 11.5247 19.4375 13.25M4.07292 6.375C3.05501 6.375 2.22917 7.21484 2.22917 8.25C2.22917 9.28516 3.05501 10.125 4.07292 10.125C5.09082 10.125 5.91667 9.28516 5.91667 8.25C5.91667 7.21484 5.09082 6.375 4.07292 6.375ZM16.3646 6.375C15.3467 6.375 14.5208 7.21484 14.5208 8.25C14.5208 9.28516 15.3467 10.125 16.3646 10.125C17.3825 10.125 18.2083 9.28516 18.2083 8.25C18.2083 7.21484 17.3825 6.375 16.3646 6.375ZM10.2187 1.375C8.52224 1.375 7.14583 2.77474 7.14583 4.5C7.14583 6.22526 8.52224 7.625 10.2187 7.625C11.9153 7.625 13.2917 6.22526 13.2917 4.5C13.2917 2.77474 11.9153 1.375 10.2187 1.375Z",
    stroke: "#494949",
    strokeWidth: 1.22917,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 13.2499C4.6875 10.1445 7.16504 7.62494 10.2187 7.62494C13.2725 7.62494 15.75 10.1445 15.75 13.2499",
    stroke: "#494949",
    strokeWidth: 1.22917,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeats);
export default __webpack_public_path__ + "static/media/Seats.6e519645a5221bb7c9804ef1760bd465.svg";
export { ForwardRef as ReactComponent };